import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "@/lib/useLenis";
import ScrollToTop from "@/components/ScrollToTop";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Work from "@/pages/Work";
import ProjectDetail from "@/pages/ProjectDetail";
import Process from "@/pages/Process";
import Referrals from "@/pages/Referrals";
import StartProject from "@/pages/StartProject";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  useLenis();
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/work" element={<Work />} />
            <Route path="/work/:slug" element={<ProjectDetail />} />
            <Route path="/process" element={<Process />} />
            <Route path="/referrals" element={<Referrals />} />
            <Route path="/start" element={<StartProject />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/privacy" element={<Legal kind="Privacy Policy" />} />
            <Route path="/cookies" element={<Legal kind="Cookies" />} />
            <Route path="/terms" element={<Legal kind="Terms & Conditions" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" />
    </div>
  );
}
export default App;
